const TC = require('./TryCatch').default

/**
 *
 * @type {(callback: any, props?: any) => Promise<unknown>}
 */
tryCatch = TC;


/**
 *
 * @param func
 * @param options
 */
preProps = (func, { defaultProps})=>{
	return function preProps({ ...props }){
		if(typeof defaultProps !=='undefined'){
			Object.keys(defaultProps).map(function (key){
				props[key] = props[key] ?? defaultProps[key];
			});
		}
		return func(props);
	}
}

/**
 *
 * @param func
 * @returns {(function(*): void)|*}
 */
func = (func)=>{
	return function (...args){
		try{
			return func(...args);
		}catch (e) {
			console.log(e);
		}
	}
}

/**
 *
 * @param type
 * @returns {boolean}
 */
isTrue = (type)=>{
	return `${process.env[type]}`.toLowerCase() === 'true'
}